import { Component, OnInit } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { FakDokumentStavka } from './fak-dokument-stavka';

@Component({
  selector: 'yt-fak-dokument-stavka-inline-update',
  templateUrl: './fak-dokument-stavka-inline-update.component.html'
})
export class FakDokumentStavkaInlineUpdateComponent
 extends BaseInlineUpdateComponent<FakDokumentStavka> {
  constructor(protected inlineContainerService: InlineContainerService<FakDokumentStavka>){
    super(inlineContainerService);
  }
}
